<template>
    <v-snackbar
        :value="loading"
        class="loading-component-snackbar"
        persistent
        color="primary"
        centered
        dark
        elevation="6"
        timeout="-1"
        multi-line
        min-width="480"
    >
        <div class="loading-component-snackbar__message">{{ displayMessage }}</div>
        <div v-if="showElapsed" class="white--text caption mb-1" style="opacity: 0.95;">
            {{ $t('system.messages.elapsedTime', { time: elapsedFormatted }) }}
        </div>
        <div
            v-if="progressPercent != null"
            class="white--text caption mb-1"
            style="opacity: 0.95;"
        >
            {{ progressPercent }}%
        </div>
        <v-progress-linear
            v-if="progressPercent == null"
            indeterminate
            rounded
            color="white"
            height="8"
        />
        <v-progress-linear
            v-else
            :value="progressPercent"
            rounded
            color="white"
            height="8"
        />
        <!-- Ações opcionais durante o carregamento (ex.: cancelar um processo longo). -->
        <div v-if="$slots.default" class="mt-2 text-right">
            <slot />
        </div>
    </v-snackbar>
</template>

<script>
export default {
    name: "LoadingComponent",
    props: {
        message: {
            type: String,
            default() {
                return this.$t('system.messages.loading');
            }
        },
        loading: {
            type: Boolean,
            default() {
                return false;
            }
        },
        /** 0–100 = barra determinada; null = indeterminada (ex.: carga da tabela). */
        progressPercent: {
            default: null,
            validator: (v) => v === null || v === undefined || (typeof v === 'number' && v >= 0 && v <= 100),
        },
        /** Exibe o tempo decorrido desde que `loading` ficou true; zera a cada novo carregamento. */
        showElapsed: {
            type: Boolean,
            default: false,
        },
    },
    data() {
        return {
            elapsedSeconds: 0,
            elapsedTimer: null,
        };
    },
    watch: {
        loading: {
            immediate: true,
            handler(value) {
                this.stopElapsedTimer();
                if (value && this.showElapsed) {
                    const inicio = Date.now();
                    this.elapsedSeconds = 0;
                    this.elapsedTimer = setInterval(() => {
                        this.elapsedSeconds = Math.floor((Date.now() - inicio) / 1000);
                    }, 1000);
                }
            },
        },
    },
    computed: {
        displayMessage() {
            if (this.progressPercent != null) {
                const prefix = this.$t('system.messages.loadingColon');
                return `${prefix} ${this.message || ''}`.trim();
            }
            return this.message;
        },
        elapsedFormatted() {
            const total = this.elapsedSeconds;
            const h = Math.floor(total / 3600);
            const m = String(Math.floor((total % 3600) / 60)).padStart(2, '0');
            const sec = String(total % 60).padStart(2, '0');
            return h > 0 ? `${h}:${m}:${sec}` : `${m}:${sec}`;
        },
    },
    beforeDestroy() {
        this.stopElapsedTimer();
    },
    methods: {
        stopElapsedTimer() {
            if (this.elapsedTimer) {
                clearInterval(this.elapsedTimer);
                this.elapsedTimer = null;
            }
        },
    },
}
</script>

<style>
/* Snackbar teleporta para o body; scoped não alcança o wrapper. */
.loading-component-snackbar .v-snack__wrapper {
    min-width: min(480px, calc(100vw - 32px));
    max-width: min(640px, calc(100vw - 32px));
    padding: 16px 20px;
}

.loading-component-snackbar .v-snack__content {
    width: 100%;
    padding: 0;
}

.loading-component-snackbar__message {
    margin-bottom: 8px;
    white-space: normal;
    word-break: break-word;
    line-height: 1.35;
    font-size: 0.95rem;
}
</style>
